
        import { inject, track } from 'https://cdn.jsdelivr.net/npm/@vercel/analytics@1.5.0/+esm';
        import { BLOCKED_PROPERTIES } from './src/config/analytics-config.js';

        // Initialize Vercel Analytics with PII filtering
        inject({
            beforeSend: (event) => {
                // Filter PII from all analytics events as last resort
                if (event.data?.properties) {
                    const filtered = Object.keys(event.data.properties).reduce((acc, key) => {
                        const isBlocked = BLOCKED_PROPERTIES.some(blocked =>
                            key.toLowerCase().includes(blocked.toLowerCase())
                        );
                        if (!isBlocked) {
                            acc[key] = event.data.properties[key];
                        }
                        return acc;
                    }, {});

                    return {
                        ...event,
                        data: {
                            ...event.data,
                            properties: filtered
                        }
                    };
                }
                return event;
            }
        });

        // Track page visit
        track('page_view', {
            page_type: 'estimate_form',
            page: 'estimate_form',
            referrer: document.referrer || undefined
        });
    